import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamera = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.66699 6.98134C1.66699 6.68941 1.66699 6.54345 1.67917 6.4205C1.79666 5.23472 2.73472 4.29666 3.9205 4.17917C4.04345 4.16699 4.19729 4.16699 4.50498 4.16699C4.62354 4.16699 4.68282 4.16699 4.73315 4.16394C5.37583 4.12502 5.93862 3.71939 6.17878 3.12199C6.19759 3.07521 6.21517 3.02247 6.25033 2.91699C6.28548 2.81152 6.30306 2.75878 6.32187 2.71199C6.56203 2.11459 7.12482 1.70896 7.7675 1.67004C7.81783 1.66699 7.87343 1.66699 7.98461 1.66699H12.016C12.1272 1.66699 12.1828 1.66699 12.2331 1.67004C12.8758 1.70896 13.4386 2.11459 13.6788 2.71199C13.6976 2.75878 13.7152 2.81152 13.7503 2.91699C13.7855 3.02247 13.8031 3.07521 13.8219 3.12199C14.062 3.71939 14.6248 4.12502 15.2675 4.16394C15.3178 4.16699 15.3771 4.16699 15.4957 4.16699C15.8034 4.16699 15.9572 4.16699 16.0801 4.17917C17.2659 4.29666 18.204 5.23472 18.3215 6.4205C18.3337 6.54345 18.3337 6.68941 18.3337 6.98134V13.5003C18.3337 14.9005 18.3337 15.6005 18.0612 16.1353C17.8215 16.6057 17.439 16.9882 16.9686 17.2278C16.4339 17.5003 15.7338 17.5003 14.3337 17.5003H5.66699C4.26686 17.5003 3.5668 17.5003 3.03202 17.2278C2.56161 16.9882 2.17916 16.6057 1.93948 16.1353C1.66699 15.6005 1.66699 14.9005 1.66699 13.5003V6.98134Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10.0003 13.7503C11.8413 13.7503 13.3337 12.2579 13.3337 10.417C13.3337 8.57604 11.8413 7.08366 10.0003 7.08366C8.15938 7.08366 6.66699 8.57604 6.66699 10.417C6.66699 12.2579 8.15938 13.7503 10.0003 13.7503Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	});
};
export default SvgCamera;
